.loader {
  display: flex;
  gap: var(--mantine-spacing-xs);
  align-items: center;
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-dark-1);
}
